import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

const ContentWrapper = styled.div`
    margin: 0.5rem 1rem;
`;

const TitleSide = styled.div`
    display: inline-block;
    width: 5rem;
    text-align: right;
    vertical-align: top;
`;

export class DataSetting extends Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        element: PropTypes.object.isRequired
    }

    state = {};

    componentDidMount() {
    }

    render() {
        return <ContentWrapper>
            <TitleSide>{this.props.title}:</TitleSide> {this.props.element}
        </ContentWrapper>
    }
}

export default DataSetting;
